import { config } from '@abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import ProviderBioFeedbackMutation from './ProviderBioFeedback.graphql';

export const useProviderBioFeedback = (options) =>
  useCustomQuery(ProviderBioFeedbackMutation, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'providerBioFeedback',
  });
